import { message, notification } from 'antd';
// import { history } from 'umi';
import {
  wrapperUrlWithPrefix,
  getToken,
  setToken,
  storageClear,
  getEnterpriseId,
  getQueryVariable,
  goPlatformLogin,
  getUUIDByLength,
} from './utils';

import { tokenRefresh } from '../services/initial';
import { stringify } from 'qs';

const codeMessage: Record<number, string> = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};
/** 异常处理程序 */
const errorHandler = (error: { response: Response }): Response => {
  const { response } = error;
  if (response && ![401, 403].includes(response.status)) {
    const errorText = codeMessage[response.status] || response.statusText;
    const { status, url } = response;
    notification.error({
      message: `请求错误 ${status}: ${url}`,
      description: errorText,
    });
  } else if (!response) {
    notification.error({
      description: '您的网络发生异常，无法连接服务器',
      message: '网络异常',
    });
  }
  return response;
};

const scorpioFetch = async (url: string, options: any, download?: boolean) => {
  if (!url) {
    throw new Error('missing parameter: url');
  }

  const {
    method = 'GET',
    data = {}, // body 入参
    messageFree = false,
    headers = {},
    tokenFree = false, // 是否不需要带 token 信息，如登录接口
    params = {}, // query 入参
    ...elseProps
  } = options;

  let { userId, token, refreshToken } = getToken();
  // alert(JSON.stringify(getToken()));
  if (!userId && !tokenFree) {
    storageClear();
    goPlatformLogin();
    return;
  }

  if (refreshToken && !token && !tokenFree) {
    const refreshRes = await tokenRefresh({ refreshToken });
    if (refreshRes?.data?.userId) {
      setToken(refreshRes?.data);
      ({ userId, token, refreshToken } = getToken());
    } else {
      storageClear();
      goPlatformLogin();
    }
  }
  // todo: 获取前缀的地方，此处区分target @孔德胜
  // if (!/^http/.test(url)) {
  //   url = domain + url;
  // }
  const spliceStr = url?.indexOf('?') !== -1 ? '&' : '?';
  const mergeUrl =
    wrapperUrlWithPrefix(url) +
    spliceStr +
    stringify({ ...params, t: Date.now() }, { arrayFormat: 'comma', encode: false });
  console.log(mergeUrl, '====mergeUrl');
  //sluth这个spring组件的要求，要是短了它会在前面补位，长了它会重新计算。往后面传递的traceId一定是16位的
  //如果要改成支持任意位数，就得把源码读了，重写某些地方，投入大了，不划算。而且所有的后端服务都要重新打包部署，来保证都支持非16位的id数据传递。
  //所以前端直接传16位，一个小限制，解决问题
  const xRequestId = getUUIDByLength(16);

  const mergeOptions = {
    method,
    credentials: 'omit',
    headers: {
      'Content-Type': 'application/json',
      'x-request-id': xRequestId,
      userId,
      // enterpriseId: getEnterpriseId(),
      userRealName: encodeURI(localStorage.getItem('userName') || ''),
      ...headers,
      ...(tokenFree
        ? {}
        : {
            Authorization: `${token?.startsWith('Jwt') ? token : 'Jwt ' + token}`,
          }),
    },
    body: JSON.stringify(data),
    ...elseProps,
  };
  if (method === 'GET') {
    delete mergeOptions.body;
  }
  try {
    let result = await fetch(mergeUrl, { ...mergeOptions });

    const { status } = result;
    if (status === 401 && !tokenFree) {
      const { refreshToken: refreshToken2 } = getToken();
      const refreshRes = await tokenRefresh({ refreshToken: refreshToken2 });

      if (refreshRes?.data?.userId) {
        setToken(refreshRes?.data);
      } else {
        storageClear();
        // message.error('刷新token出错');
        goPlatformLogin();
        return;
      }

      const { token: token2 } = getToken();
      result = await fetch(mergeUrl, {
        ...mergeOptions,
        headers: {
          ...mergeOptions.headers,
          Authorization: `${token2?.startsWith('Jwt') ? token2 : 'Jwt ' + token2}`,
        },
      });
    }
    if (download) {
      const blob = await result.blob();
      return { data: blob };
    }
    const jsonRes = await result.clone().json();
    if (
      (jsonRes?.code && String(jsonRes?.code).toLowerCase() !== 'success') ||
      result.status !== 200
    ) {
      if (result.status !== 200) {
        errorHandler({ response: result });
      }
      // {"code":"USERNAMEORPASSWORD_ERROR","message":"用户名或密码错误","details":"Bad credentials"}
      if (!messageFree) {
        message.error(jsonRes?.message || '请求出错');
      }

      return {
        success: false,
        data: jsonRes,
        errorCode: jsonRes?.code || result.status,
        errorMessage: jsonRes?.message || '请求出错',
        status: result.status,
      };
    }

    const returnData = {
      success: true,
      data: jsonRes,
      code: result.status,
    };

    return returnData;
  } catch (err) {
    console.log('trycatch=====', err);
    errorHandler({ response: err as Response });
    return {
      success: false,
      data: {},
      errorCode: null,
      errorMessage: '网络错误123',
    };
  }
};

export default scorpioFetch;
